import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FutureBuildersLab from "@/pages/FutureBuildersLab";
import Sponsor from "@/pages/Sponsor";
import StudentInterest from "@/pages/StudentInterest";
import ParentInfo from "@/pages/ParentInfo";
import Partner from "@/pages/Partner";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Placeholder from "@/pages/Placeholder";
import JsonLd from "@/components/brand/JsonLd";
import { ORG_SCHEMA } from "@/lib/schema";

function App() {
    return (
        <div className="App">
            {/* Site-wide Organization / EducationalOrganization JSON-LD */}
            <JsonLd data={ORG_SCHEMA} />
            <BrowserRouter>
                <Routes>
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route
                            path="/future-builders-lab"
                            element={<FutureBuildersLab />}
                        />
                        <Route path="/sponsor" element={<Sponsor />} />
                        <Route
                            path="/student-interest"
                            element={<StudentInterest />}
                        />
                        <Route path="/parent-info" element={<ParentInfo />} />
                        <Route path="/partner" element={<Partner />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route
                            path="*"
                            element={<Placeholder pageName="Page Not Found" />}
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
